/* eslint-disable react/prop-types */
import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Snack from "@material-ui/core/SnackbarContent";
import IconButton from "@material-ui/core/IconButton";
// core components
import snackbarContentStyle from "assets/jss/material-dashboard-react/components/snackbarContentStyle.jsx";
import { makeAPICall } from "services/userDataProvider.js";

function SnackbarContent({ ...props }) {
  const { classes, message, color, iconColor, open, close, icon, data } = props;
  const [popupMessage, setPopupMessage] = useState(null);
  var action = [];
  const messageClasses = classNames({
    [classes.iconMessage]: icon !== undefined
  });

  const normalizeActions = () => {
    if (!data || !data.actions) {
      return [];
    }
    return Array.isArray(data.actions) ? data.actions : [data.actions];
  };

  const handleShowMessage = message => {
    setPopupMessage(message);
    // Auto-hide after 5 seconds
    setTimeout(() => {
      setPopupMessage(null);
    }, 5000);
  };

  const getActionButtonClass = buttonColor => {
    const key = (buttonColor || color || "primary").toLowerCase();
    const capitalized = key.charAt(0).toUpperCase() + key.slice(1);
    const toneClass = classes[`actionButton${capitalized}`];
    return classNames(
      classes.actionButton,
      toneClass || classes.actionButtonPrimary
    );
  };

  action = [];
  if (open !== undefined) {
    action.push(
      <IconButton
        className={classes.iconButton}
        key="open"
        aria-label="Open"
        color="inherit"
      >
        {/* <Open className={classes.open} onClick={props.openNotification} /> */}
        <i className="material-icons" onClick={props.openNotification}>
          near_me
        </i>
      </IconButton>
    );
  }
  if (close !== undefined) {
    action.push(
      <IconButton
        className={classes.iconButton}
        key="close"
        aria-label="Close"
        color="inherit"
      >
        <i className="material-icons" onClick={props.closeNotification}>
          cancel
        </i>
      </IconButton>
    );
  }

  const actionButtons = normalizeActions().length ? (
    <div className={classes.actionButtons}>
      {normalizeActions().map((actionItem, index) => (
        <button
          key={index}
          className={getActionButtonClass(actionItem.color)}
          onClick={() => {
            if (actionItem.type === "api" && actionItem.path) {
              // Handle API call
              makeAPICall(props.axios, actionItem.path, "GET")
                .then(data => {
                  console.log("API action response data:", data);
                  data.message && handleShowMessage(data.message);
                })
                .catch(err => {
                  console.error(err);
                  handleShowMessage(
                    "Something went wrong while performing the action."
                  );
                });
            }
            if (props.closeNotification) {
              props.closeNotification();
            }
          }}
        >
          {actionItem.label}
        </button>
      ))}
    </div>
  ) : null;

  return (
    <div>
      <Snack
        message={
          <div>
            <div>
              {icon !== undefined ? (
                <props.icon
                  className={classNames(
                    classes.icon,
                    classes[`${iconColor || color}Icon`] || null
                  )}
                />
              ) : null}
              <span className={messageClasses}>{message}</span>
            </div>
            {actionButtons}
          </div>
        }
        classes={{
          root: classes.root + " " + classes[color],
          message: classes.message
        }}
        action={action}
        open={open}
      />

      {/* Popup message that auto-disappears */}
      {popupMessage && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#333",
            color: "white",
            padding: "20px 30px",
            borderRadius: "8px",
            zIndex: 9999,
            maxWidth: "400px",
            textAlign: "center",
            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
            fontSize: "16px"
          }}
        >
          {popupMessage}
        </div>
      )}
    </div>
  );
}

SnackbarContent.propTypes = {
  classes: PropTypes.object.isRequired,
  message: PropTypes.node.isRequired,
  data: PropTypes.shape({
    link: PropTypes.string,
    old_vo2_max: PropTypes.number,
    new_vo2_max: PropTypes.number,
    improvement_percentage: PropTypes.number,
    actions: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        type: PropTypes.string,
        url: PropTypes.string,
        color: PropTypes.string
      })
    )
  }),
  color: PropTypes.oneOf(["info", "success", "warning", "danger", "primary"]),
  iconColor: PropTypes.oneOf([
    "info",
    "success",
    "warning",
    "danger",
    "primary"
  ]),
  close: PropTypes.bool,
  icon: PropTypes.func,
  onActionClick: PropTypes.func,
  openNotification: PropTypes.func,
  closeNotification: PropTypes.func
};

export default withStyles(snackbarContentStyle)(SnackbarContent);
